<template>
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M7.77344 2.65625V7.77344H2.65625V2.65625H7.77344ZM7.77344 1.25H2.65625C1.87891 1.25 1.25 1.87891 1.25 2.65625V7.77344C1.25 8.55078 1.87891 9.17969 2.65625 9.17969H7.77344C8.55078 9.17969 9.17969 8.55078 9.17969 7.77344V2.65625C9.17969 1.87891 8.55078 1.25 7.77344 1.25ZM17.3438 2.65625V7.77344H12.2266V2.65625H17.3438ZM17.3438 1.25H12.2266C11.4492 1.25 10.8203 1.87891 10.8203 2.65625V7.77344C10.8203 8.55078 11.4492 9.17969 12.2266 9.17969H17.3438C18.1211 9.17969 18.75 8.55078 18.75 7.77344V2.65625C18.75 1.87891 18.1211 1.25 17.3438 1.25ZM7.77344 12.2266V17.3438H2.65625V12.2266H7.77344ZM7.77344 10.8203H2.65625C1.87891 10.8203 1.25 11.4492 1.25 12.2266V17.3438C1.25 18.1211 1.87891 18.75 2.65625 18.75H7.77344C8.55078 18.75 9.17969 18.1211 9.17969 17.3438V12.2266C9.17969 11.4492 8.55078 10.8203 7.77344 10.8203ZM17.3438 12.2266V17.3438H12.2266V12.2266H17.3438ZM17.3438 10.8203H12.2266C11.4492 10.8203 10.8203 11.4492 10.8203 12.2266V17.3438C10.8203 18.1211 11.4492 18.75 12.2266 18.75H17.3438C18.1211 18.75 18.75 18.1211 18.75 17.3438V12.2266C18.75 11.4492 18.1211 10.8203 17.3438 10.8203Z"
      fill="currentColor"
    />
  </svg>
</template>
<script lang="ts">
import type { DefineComponent } from 'vue'
export default {
  name: 'AppstoreO',
} as DefineComponent
</script>
